<div class="ph-item" *ngIf="type === loaderType.avatar || type === loaderType.content">
  <div class="ph-col-12">
    <div *ngIf="type === loaderType.avatar" class="ph-avatar"></div>
    <ng-container *ngIf="type === loaderType.content"
      ><div class="ph-row" *ngFor="let lineWidth of totalLines">
        <div
          [ngClass]="'ph-col-' + lineWidth"
          [ngStyle]="{ height: lineHeight + 'px', 'margin-bottom': lineGutter + 'px' }"
        ></div></div
    ></ng-container>
  </div>
</div>
<div class="nibras-spinner" *ngIf="type === loaderType.spinner">
  <img [style.width.px]="size" src="assets/images/loader.gif" />
</div>
<ng-container *ngIf="text && type === loaderType.spinnerSmall; else spinnerSmall">
  <div class="loader-wrapper">
    <ng-container *ngTemplateOutlet="spinnerSmall"></ng-container>
    {{ text }}
  </div>
</ng-container>
<app-show-progress *ngIf="type === loaderType.dotProgress"></app-show-progress>

<ng-template #spinnerSmall>
  <div class="nibras-spinner-small" *ngIf="type === loaderType.spinnerSmall">
    <mat-spinner [diameter]="size" [color]="color"></mat-spinner>
  </div>
</ng-template>
